import { type Ref } from 'vue'
import { ref } from 'vue'
import { getDocument } from '@/helpers/globals'

// step is the number of pixels the mouse travels before the image changes
export function useThreeSixtyInput(
    currentImageIndex: Ref<number>,
    step = ref(10)
): {
    handleTouchStart: (e: TouchEvent) => void
    handleTouchMove: (e: TouchEvent) => void
    handleMouseDown: (e: MouseEvent) => void
} {
    let xStart = 0
    let xEnd = 0
    let initialImageIndex = 0

    const handleStart = (x: number | undefined) => {
        if (typeof x !== 'number') {
            return
        }

        xStart = x
        xEnd = x
        initialImageIndex = currentImageIndex.value
    }

    const handleMove = (x: number | undefined) => {
        if (typeof x !== 'number') {
            return
        }

        xEnd = x

        const diff = xEnd - xStart

        currentImageIndex.value =
            Math.round(diff / step.value) + initialImageIndex
    }

    function handleTouchStart(e: TouchEvent): void {
        handleStart(e.touches[0]?.clientX)
    }

    function handleTouchMove(e: TouchEvent): void {
        handleMove(e.touches[0]?.clientX)
    }

    function handleMouseDown(e: MouseEvent): void {
        handleStart(e.clientX)

        const document = getDocument()

        if (document) {
            document.addEventListener('mousemove', handleMouseMove)
            document.addEventListener(
                'mouseup',
                () => {
                    document.removeEventListener('mousemove', handleMouseMove)
                },
                {
                    once: true,
                }
            )
        }
    }

    function handleMouseMove(e: MouseEvent): void {
        handleMove(e.clientX)
    }

    return {
        handleTouchStart,
        handleTouchMove,
        handleMouseDown,
    }
}
